<template>
    <div class="pl-column-edit-item" @click="handleClick">
        <keep-alive>
            <link-address-input
                v-if="lv_editable"

                :row="showRow"
                :map="map"
                :types="types"
                :title="title"

                :required="lv_required"
                :rules="rules"
                :validate-on-init="validateOnInit"
            />
            <template v-else>
                <link-table-cell-normal
                    :render-func="renderFunc"
                    :scope-slot-func="scopeSlotFunc"
                    :text="showRow[field]"
                    :data="scopeSlotData"/>
            </template>
        </keep-alive>
    </div>
</template>

<script>
    import {ColumnItemMixin} from "../mixins";
    import LvColumnText from "../lv-column-text";
    import LvScopeSlot from "../../render/lv-scope-slot";

    export default {
        name: "link-table-column-address-item",
        components: {LvScopeSlot, LvColumnText},
        mixins: [ColumnItemMixin],
        props: {
            map: {require: true},
            /*@formatter:off*/
            types: {type: Array, default: () => {return ['province', 'city', 'district']}},                 // 设定link-address-modal的类型和返回数据形式
            title: {type: String, default: '请选择地址'},                                                    // 设定弹框标题
        },
    }
</script>
